import { Box, Button, Divider } from '@capitalise/ui-design-system';
import { MouseEventHandler } from 'react';

export interface IHelpButtonProps {
  helpLabel: JSX.Element;
  buttonLabel: string;
  onClickCallback: MouseEventHandler<HTMLButtonElement>;
}

const HelpButton = ({ helpLabel, buttonLabel, onClickCallback }: IHelpButtonProps) => {
  return (
    <Box display="flex" flexDirection="column" gridGap="3xsmall">
      <Divider color="grey-50" />
      <Box display="flex" flexDirection={{ _: 'column', '2xl': 'row' }} gridGap="3xsmall">
        <Box flex="1">{helpLabel}</Box>
        <Box display="flex" alignItems="center">
          <Button baseColor="green" onClick={onClickCallback} variant="outlined">
            {buttonLabel}
          </Button>
        </Box>
      </Box>
      <Divider color="grey-50" />
    </Box>
  );
};

export default HelpButton;
